var React = require('react');
var ReactNative = require('react-native');

var {
  Linking,
} = ReactNative;

module.exports = {
  call : function(phoneNumber) {
    var url = "tel://" + phoneNumber;
    Linking.openURL(url);
  },

  canCall : function(completion) {
    Linking.canOpenURL("tel://1231231234", completion);
  }
}



// WEBPACK FOOTER //
// ./src/wrappers/PhoneManager-wrapper.js